/* eslint-disable max-len */
export const URL_REGEX = /^(?:(?:(?:https?|ftp):)?\/\/)?(?:www\.)?([a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+)(?::\d{1,5})?(?:\/[^#\s]*)?(?:\?[^\s]*)?(?:#[^\s]*)?$/i;
